var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ width: _vm.width, heigth: _vm.height })},_vm._l((_vm.endValue),function(item,index){return _c('div',{key:index,staticStyle:{"display":"inline-block"},style:({
      fontSize: _vm.fontSize(),
      fontFamily: _vm.chartConfig.fontFamily,
      color: _vm.chartConfig.color,
      textAlign: _vm.align,
      verticalAlign: _vm.valign,
      letterSpacing: _vm.letterSpacing,
      fontWeight: _vm.chartConfig.fontWeight,
      border: _vm.chartConfig.border,
      backgroundColor: _vm.chartConfig.backgroundColor,
      backgroundImage: _vm.getBackgroundImage,
      margin: _vm.chartConfig.margin,
      padding: _vm.chartConfig.padding,
    })},[(item != '.')?_c('numberComponents',{attrs:{"playTimer":_vm.animalConfig.playTimer,"isOpenPlayTimer":_vm.animalConfig.isOpenPlayTimer,"duration":_vm.animalConfig.duration,"endValue":item}}):_c('span',[_vm._v(_vm._s(item))])],1)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bde8f79","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Number.vue
// module id = 854
// module chunks = 0